import React from 'react'
import styles from './description.styles'
import injectSheet from 'react-jss'

const Description = ({ classes, children }) => (
  <div className={classes.container}>{children}</div>
)

export default injectSheet(styles)(Description)
